<template>
	<div class="edit-user">
		<el-form :model="userRuleForm" :rules="userRules" ref="userRuleForm">
			<el-form-item prop="number">
				<div class="create-user-form-each">
					<img src="../../assets/common/icons/user/userNumber.png" />
					<span>工号</span>
				</div>
				<el-input v-model="userRuleForm.number" placeholder="请输入工号"></el-input>
			</el-form-item>
			<el-form-item prop="name">
				<div class="create-user-form-each">
					<img src="../../assets/common/icons/user/userName.png" />
					<span>称谓</span>
				</div>
				<el-input v-model="userRuleForm.name" placeholder="请输入称谓"></el-input>
			</el-form-item>
			<el-form-item prop="role">
				<div class="create-user-form-each">
					<img src="../../assets/common/icons/user/userRole.png" />
					<span>所属角色</span>
				</div>
				<el-select v-model="userRuleForm.role" placeholder="请选择" @change="changeUserRole">
					<el-option v-for="(item, index) in userRolesList" :key="index" :label="item.detail" :value="item.id"
						v-if="item.id && ((userType==1 && (item.id==1 || item.id==2)) || (userType==2 && (item.id!=1 && item.id!=2)))">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="belong">
				<div class="create-user-form-each">
					<img src="../../assets/common/icons/user/userBelong.png" />
					<span>所属部门</span>
				</div>
				<div>
					<el-checkbox v-model="userBelongToParty" @change="updateUserBelong(1)">党办</el-checkbox>
					<el-checkbox v-model="userBelongToSchool" @change="updateUserBelong(2)">校办</el-checkbox>
				</div>
			</el-form-item>
			<el-form-item prop="manager">
				<div class="create-user-form-each">
					<img src="../../assets/common/icons/user/userManage.png" />
					<span v-if="userType == 1">联络员</span>
					<span v-if="userType == 2">校领导</span>
					<div class="create-user-form-each-leader-number"
						v-if="userRuleForm && userRuleForm.manageUsers && userRuleForm.manageUsers.length > 0">
						<span>·</span>
						<span>{{userRuleForm.manageUsers.length}}</span>
					</div>
				</div>
				<div class="create-user-form-managers">
					<div class="create-user-form-managers-list"
						v-if="userRuleForm.manageUsers && userRuleForm.manageUsers.length > 0">
						<div class="create-user-form-managers-list-each"
							v-for="(item, index) in userRuleForm.manageUsers" :key="index" v-if="item">
							<span>{{item.name}}</span>
						</div>
					</div>
					<el-popover placement="top-start" width="240" trigger="click" ref="managerListPopover">
						<div class="create-user-form-managers-select">
							<div class="managers-select-list">
								<div class="managers-select-list-each" v-for="(item, index) in memberList" :key="index">
									<div class="managers-select-list-each-info">
										<el-checkbox v-model="item.isJoined" :disabled="item.disabled"
											@change="addManagerToUser($event, index)"></el-checkbox>
										<img src="../../assets/common/userHeadImg_Default.png" />
										<span>{{item.name}}</span>
									</div>
								</div>
							</div>
							<el-button type="primary" @click="updateUserManagerList">确定</el-button>
						</div>
						<i class="el-icon-circle-plus" slot="reference" style="cursor: pointer;"></i>
					</el-popover>
				</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button v-if="useMode=='create'" type="primary" @click="confirmEditUser(1)"
				:loading="confirmEditLoading">保存</el-button>
			<el-button v-if="useMode=='edit'" type="success" @click="confirmEditUser(2)"
				:loading="confirmEditLoading">保存</el-button>
			<el-popover placement="top" width="400" trigger="click" ref="deletePopover"
				popper-class="user-list-table-btns-popover">
				<el-button v-if="useMode=='edit'" type="danger" slot="reference">删除</el-button>
				<tipsModal :modalTitle="'温馨提示'" :modalContent="'确定删除此用户？'" @hideModal="hideModal"
					@modalConfirm="modalConfirm">
				</tipsModal>
			</el-popover>
		</div>
	</div>
</template>

<script>
	import tipsModal from '../tools/TipsModal.vue';
	export default {
		components: {
			tipsModal
		},
		props: {
			useMode: { //用户操作
				type: String,
				default: ''
			},
			userType: { //用户身份类别
				type: Number,
				default: 1
			},
			userRolesList: { //用户角色列表
				type: Array,
				default: []
			},
			userInfo: { //待编辑的用户信息
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		data() {
			return {
				confirmEditLoading: false, //编辑用户按钮加载状态
				userBelongToParty: true, //用户所属部门——党办
				userBelongToSchool: false, //用户所属部门——校办
				memberList: [], //人员列表
				userRuleForm: {
					number: '',
					name: '',
					role: '',
					belong: 1,
					manager: '',
					manageUsers: []
				}, //用户编辑表单规则
				userRules: {
					number: [{
						required: true,
						message: '请输入工号',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入称谓',
						trigger: 'blur'
					}],
					role: [{
						required: true,
						message: '请选择所属角色',
						trigger: 'change'
					}],
					belong: [{
						required: true,
						message: '请选择所属部门',
						trigger: 'change'
					}]
				}
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {})
		},
		watch: {
			userType: {
				handler(newUserType, oldUserType) {
					let that = this;
				},
				immediate: true,
				deep: true
			},
			userInfo: {
				handler(newUserInfo, oldUserInfo) {
					let that = this;
					that.getAllUsers();
				},
				immediate: true,
				deep: true
			}
		},
		methods: {
			//查询可选择的人员列表
			getAllUsers() {
				let that = this;
				let params = {
					type: that.userType == 1 ? 2 : that.userType == 2 ? 1 : 1,
					userId: that.userInfo ? that.userInfo.id : ''
				};
				that.$api.getAllUsers(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						res.data.forEach((item, index) => {
							item.isJoined = false;
							item.disabled = false;
						})
						that.memberList = res.data;
						if (that.userInfo) {
							that.loadUserInfo();
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//加载用户信息
			loadUserInfo() {
				let that = this;
				that.userRuleForm = that.userInfo;
				// console.log(that.userRuleForm)
				that.userBelongToParty = true;
				that.userBelongToSchool = false;
				if (that.userRuleForm.belong == 2) {
					that.userBelongToParty = false;
					that.userBelongToSchool = true;
				}
				that.memberList.forEach((item, index) => {
					item.isJoined = false;
					item.disabled = false;
				})
				if (that.userRuleForm.manageUsers && that.userRuleForm.manageUsers.length > 0) {
					that.userRuleForm.manageUsers.forEach((item, index) => {
						that.memberList.forEach((memberItem, memberIndex) => {
							if (item.id == memberItem.id) {
								memberItem.isJoined = true;
							}
						})
					})
				}
				if (that.userRuleForm.role == 3) {
					let num = 0;
					that.memberList.forEach((item, index) => {
						if (item.isJoined) {
							num = num + 1;
						}
					})
					if (num == 1) {
						that.memberList.forEach((item, index) => {
							if (!item.isJoined) {
								item.disabled = true;
							}
						})
					}
				}
			},
			//点击选择用户角色
			changeUserRole(e) {
				let that = this;
				that.userRuleForm.role = e;
				if (e == 3) {
					let num = 0;
					that.memberList.forEach((item, index) => {
						if (item.isJoined) {
							num = num + 1;
						}
					})
					if (num > 1) {
						that.memberList.forEach((item, index) => {
							item.isJoined = false;
						})
						that.userRuleForm.manageUsers = [];
					}
				} else {
					that.memberList.forEach((item, index) => {
						item.disabled = false;
					})
				}
			},
			//修改用户所属部门
			updateUserBelong(flag) {
				let that = this;
				that.userRuleForm.belong = flag;
				if (flag == 1) {
					that.userBelongToParty = true;
					that.userBelongToSchool = false;
				} else if (flag == 2) {
					that.userBelongToParty = false;
					that.userBelongToSchool = true;
				}
			},
			//点击确定选择用户绑定的管理人员
			updateUserManagerList() {
				let that = this;
				that.userRuleForm.manageUsers = [];
				that.memberList.forEach((item, index) => {
					if (item.isJoined) {
						if (that.userRuleForm.manageUsers.length == 0) {
							that.userRuleForm.manageUsers.push(item);
						} else {
							let hasAdded = false;
							that.userRuleForm.manageUsers.forEach((userItem, userIndex) => {
								if (item.id == userItem.id) {
									hasAdded = true;
								}
							})
							if (!hasAdded) {
								that.userRuleForm.manageUsers.push(item);
							}
						}
					}
				})
				that.$refs['managerListPopover'].doClose();
				that.$forceUpdate();
			},
			//点击选择管理人员绑定给该用户
			addManagerToUser(e, flag) {
				let that = this;
				if (e) {
					that.memberList[flag].isJoined = true;
				} else {
					that.memberList[flag].isJoined = false;
				}
				let num = 0;
				that.memberList.forEach((item, index) => {
					if (item.isJoined) {
						num = num + 1;
					}
					item.disabled = false;
				})
				if (that.userRuleForm.role == 3 && num == 1) {
					that.memberList.forEach((item, index) => {
						if (index != flag) {
							item.disabled = true;
						}
					})
				}
				that.$forceUpdate();
			},
			//确认编辑用户
			confirmEditUser(flag) {
				let that = this;
				console.log(that.userRuleForm)
				that.confirmEditLoading = true;
				that.$refs["userRuleForm"].validate((valid) => {
					if (valid) {
						setTimeout(function() {
							that.confirmEditLoading = false;
							let params = that.userRuleForm;
							if (flag == 1) {
								that.userRuleForm.type = that.userType;
								that.$api.addUser(params).then(res => {
									console.log(res)
									if (res.code == 1) {
										that.$emit("confirmEditUser");
									}
								}).catch(err => {
									console.log()
								})
							} else if (flag == 2) {
								that.$api.updateUser(params).then(res => {
									console.log(res)
									if (res.code == 1) {
										that.$emit("confirmEditUser");
									}
								}).catch(err => {
									console.log()
								})
							}
						}, 1000);
					} else {
						that.confirmEditLoading = false;
						return false;
					}
				});
			},
			//点击隐藏删除用户弹窗提示
			hideModal() {
				let that = this;
				that.$refs['deletePopover'].doClose();
			},
			//点击删除用户
			modalConfirm() {
				let that = this;
				that.$refs['deletePopover'].doClose();
				that.deleteUser();
			},
			//删除用户
			deleteUser() {
				let that = this;
				let params = that.userRuleForm;
				that.$api.deleteUser(params).then(res => {
					console.log(res)
					if (res.code == 1) {
						that.$emit("confirmEditUser");
					}
				}).catch(err => {
					console.log(err)
				})
			}
		},
	}
</script>

<style lang="scss">
	.edit-user {
		.el-button--primary {
			background: #1A66FE;
			font-weight: 400;
			color: #FCFCFC;
		}

		.el-input__inner {
			border-color: #ACABA8;
			font-weight: 400;
			color: #666666;
		}

		.el-input__inner::placeholder {
			color: #666666;
		}

		.el-checkbox__label {
			font-weight: 400;
			color: #333333;
		}

		.el-checkbox__input.is-checked .el-checkbox__inner,
		.el-checkbox__input.is-indeterminate .el-checkbox__inner {
			background-color: #2ACC72;
			border-color: #2ACC72;
		}

		.el-checkbox__input.is-checked+.el-checkbox__label {
			color: #333;
		}

		.el-form-item__content {
			font-size: 35px;
			color: #1A66FE;
		}

		.el-button--success {
			background-color: #3F79F7;
			border-color: #3F79F7;
		}

		.el-button--success,
		.el-button--danger {
			font-weight: 400;
			color: #FCFCFC;
		}

		.create-user-form-each {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			img {}

			span {
				font-weight: 400;
				color: #333333;
			}

			.create-user-form-each-leader-number {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				span {
					font-weight: bold;
					color: #FE012B;
				}
			}
		}

		.create-user-form-managers {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			.create-user-form-managers-list {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;

				.create-user-form-managers-list-each {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					position: relative;

					span {
						font-weight: 400;
						color: #333333;
					}

					img {
						position: absolute;
						top: 0;
						right: -25%;
					}
				}
			}
		}

		.dialog-footer {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}
	}

	.create-user-form-managers-select {
		.managers-select-list {
			overflow: scroll;

			.managers-select-list-each {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;

				.managers-select-list-each-info {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: flex-start;
				}
			}
		}

		.el-button--primary {
			width: 100%;
		}
	}

	.user-list-table-btns-popover {
		padding: 0;
		border: 0;
		overflow: hidden;
	}

	@media screen and (min-width: 1024px) {
		.edit-user {
			padding: 0 24px;
		
			.el-button--primary {
				border-radius: 14px;
				width: 242px;
				font-size: 17px;
			}
		
			.el-input__inner {
				font-size: 14px;
				height: 31px;
			}
		
			.el-checkbox__label {
				font-size: 14px;
				line-height: 24px;
			}
		
			.el-checkbox__inner {
				width: 21px;
				height: 21px;
				border-radius: 4px;
			}
		
			.el-checkbox__inner::after {
				border: 2px solid #FFF;
				border-left: 0;
				border-top: 0;
				height: 11px;
				left: 6px;
				top: 1px;
				width: 5px;
			}
		
			.el-button--success,
			.el-button--danger {
				width: 171px;
				border-radius: 6px;
				margin: 0 14px;
				font-size: 18px;
			}
			
			.el-form-item__content{
				line-height: 1;
			}
		
			.create-user-form-each {
				margin: 0 0 9px;
		
				img {
					width: 25px;
					height: 25px;
				}
		
				span {
					font-size: 14px;
					margin: 0 0 0 12px;
				}
		
				.create-user-form-each-leader-number {
					span {
						margin: 0 0 0 3px;
						font-size: 18px;
					}
		
					span:last-child {
						margin: 0 0 0 3px;
					}
				}
			}
		
			.create-user-form-managers {
				.create-user-form-managers-list {
					.create-user-form-managers-list-each {
						margin: 0 34px 0 0;
		
						span {
							font-size: 14px;
						}
		
						img {
							width: 18px;
							height: 18px;
						}
					}
				}
			}
		
			.dialog-footer {}
		}
		
		.create-user-form-managers-select {
			.managers-select-list {
				max-height: 170px;
				margin: 20px 0;
		
				.managers-select-list-each {
					margin: 0 0 10px;
		
					.managers-select-list-each-info {
						img {
							width: 16px;
							height: 16px;
							margin: 0 8px;
						}
					}
				}
			}
		}
		
		.user-list-table-btns-popover {
			border-radius: 11px;
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.edit-user {
			padding: 0 50px;

			.el-button--primary {
				border-radius: 21px;
				width: 400px;
				height: 60px;
				font-size: 27px;
			}

			.el-input__inner {
				font-size: 21px;
				height: 50px;
			}

			.el-checkbox__label {
				font-size: 21px;
				line-height: 50px;
			}

			.el-checkbox__inner {
				width: 35px;
				height: 35px;
				border-radius: 7px;
			}

			.el-checkbox__inner::after {
				border: 3px solid #FFF;
				border-left: 0;
				border-top: 0;
				height: 20px;
				left: 9px;
				top: 1px;
				width: 12px;
			}

			.el-button--success,
			.el-button--danger {
				width: 280px;
				height: 60px;
				border-radius: 11px;
				margin: 0 25px;
				font-size: 28px;
			}

			.create-user-form-each {
				margin: 0 0 12px;

				img {
					width: 40px;
					height: 40px;
				}

				span {
					font-size: 23px;
					margin: 0 0 0 20px;
				}

				.create-user-form-each-leader-number {
					span {
						margin: 0 0 0 5px;
						font-size: 30px;
					}

					span:last-child {
						margin: 0 0 0 5px;
					}
				}
			}

			.create-user-form-managers {
				.create-user-form-managers-list {
					.create-user-form-managers-list-each {
						margin: 0 34px 0 0;

						span {
							font-size: 23px;
						}

						img {
							width: 22px;
							height: 22px;
						}
					}
				}
			}

			.dialog-footer {}
		}

		.create-user-form-managers-select {
			.managers-select-list {
				max-height: 170px;
				margin: 20px 0;

				.managers-select-list-each {
					margin: 0 0 10px;

					.managers-select-list-each-info {
						img {
							width: 30px;
							height: 30px;
							margin: 0 8px;
						}
					}
				}
			}
		}

		.user-list-table-btns-popover {
			border-radius: 11px;
		}
	}

	@media screen and (min-width: 1920px) {}
</style>